import { Box, Card, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { GoPrimitiveDot } from 'react-icons/go';
import { HiCheckCircle } from 'react-icons/hi';
import { getVendorImportStats, IVendorImportStats } from 'wisestep-api';
import {
  WsColors,
  WsIconText,
  WsListingLoader,
  WsTitleColors,
  WsTitleHeader,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  timeSince,
} from 'wisestep-base';

import NoDataFoundCard from '../../../../../components/noDataFoundCard';
import BrandLogo from '../../../../../images/BrandLogo.svg';

const ImportHistoryCard = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [vendorList, setVendorList] = useState<IVendorImportStats[]>();

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        setLoader(true);
        const response = await getVendorImportStats();
        setLoader(false);
        setVendorList(response.data);
      } catch (e) {
        setLoader(false);
      }
    };

    fetchVendors();
  }, [setLoader]);
  return (
    <Box>
      {vendorList && vendorList.length > 0 && !loader ? (
        vendorList?.map((vendor, index) => (
          <Box pt={2} key={index}>
            <Card variant="outlined">
              <Grid item xs={12} p={2} container>
                <Grid item container xs={4} columnGap={2}>
                  <img src={BrandLogo} alt="Brand Logo" />
                  <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
                    {vendor.importedFileOriginalName ?? ''}
                  </WsTypography>
                </Grid>
                <Grid item xs={8} container columnGap={2} justifyContent="flex-end">
                  <WsIconText
                    text={`${vendor.importStatus}`}
                    icon={<HiCheckCircle color={WsColors.TheBlues500} size={20} />}
                    textColor={WsTypoColors.PRIMARY}
                  />
                  <WsIconText
                    text={`Uploaded by ${vendor.createdByEmail} ${timeSince(
                      String(vendor.createdOn)
                    )}`}
                    icon={<GoPrimitiveDot />}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} p={2} container justifyContent="space-between">
                <WsTitleHeader
                  title={`${vendor.requested}`}
                  subtitle="Requested"
                  reversed={true}
                  color={WsTitleColors.BLACK}
                />
                <WsTitleHeader
                  title={`${vendor.processed}`}
                  subtitle="Processed"
                  reversed={true}
                  color={WsTitleColors.BLACK}
                />
                <WsTitleHeader
                  title={`${vendor.valid}`}
                  subtitle="Valid"
                  reversed={true}
                  color={WsTitleColors.BLACK}
                />
                <WsTitleHeader
                  title={`${vendor.invalid}`}
                  subtitle="Invalid"
                  reversed={true}
                  color={WsTitleColors.BLACK}
                />
                <WsTitleHeader
                  title={`${vendor.duplicate}`}
                  subtitle="Duplicate"
                  reversed={true}
                  color={WsTitleColors.BLACK}
                />
                <WsTitleHeader
                  title={`${vendor.validationPending}`}
                  subtitle="Pending"
                  reversed={true}
                  color={WsTitleColors.BLACK}
                />
              </Grid>
            </Card>
          </Box>
        ))
      ) : loader ? (
        <WsListingLoader />
      ) : (
        <NoDataFoundCard text="No Vendors Found" />
      )}
    </Box>
  );
};
export default ImportHistoryCard;
